if (!customElements.get('product-card-auction')) {
  redirectProductPageToAuctionIfNeeded();

    customElements.define(
      'product-card-auction',
      class ProductCardAuction extends HTMLElement {
        constructor() {
          super();
          this.auctionFetchStarted = false;
        }

        connectedCallback() {
          const variantId = this.dataset.variantId;
          const productTags = this.dataset.productTags || '';

          const hasAuctionTag = this.getAuctionStartTag(productTags) !== null;

          if (hasAuctionTag) {
            this.hidePriceContainer();
          }

          if (variantId && !this.auctionFetchStarted) {
            this.auctionFetchStarted = true;
            this.fetchAuctionPrice(variantId, productTags);
          }

          this.setupClickHandler(productTags, variantId);
        }

        hidePriceContainer() {
          const priceContainer = this.querySelector('.price');
          if (priceContainer) {
            priceContainer.style.visibility = 'hidden';
          }
        }

        showPriceContainer() {
          const priceContainer = this.querySelector('.price');
          if (priceContainer) {
            priceContainer.style.visibility = 'visible';
          }
        }

        setupClickHandler(tagsString, variantId) {
          const auctionStartTag = this.getAuctionStartTag(tagsString);

          if (!auctionStartTag) return;

          const formattedDateTime = this.extractAuctionDateTimeForUrl(auctionStartTag);
          if (!formattedDateTime) return;

          const auctionAppUrl = window.__APP_CONFIG__?.AUCTION_APP_URL || 'https://auction.ankandet.com';
          const auctionUrl = `${auctionAppUrl}/auction/${variantId}/${formattedDateTime}`;

          const card = this.closest('.card-wrapper');
          if (card) {
            const links = card.querySelectorAll('a.full-unstyled-link');
            links.forEach(link => {
              // Switch to the auction URL only on first interaction. The load-more app counts newly
              // appended cards by their /products/ links and stops loading when it finds none.
              const useAuctionUrl = () => link.setAttribute('href', auctionUrl);
              ['pointerdown', 'touchstart', 'focus', 'mouseenter', 'click'].forEach(type =>
                link.addEventListener(type, useAuctionUrl, { once: true, passive: true })
              );
            });
          }
        }

        async fetchAuctionPrice(variantId, tagsString) {
          const auctionTag = this.getAuctionStartTag(tagsString);

          if (!auctionTag) return;
          const dateForUrl = this.extractAuctionDateTimeForUrl(auctionTag);
          if (!dateForUrl) {
            this.showPriceContainer();
            return;
          }

          const baseUrl = window.__APP_CONFIG__?.API_URL;
          if (!baseUrl) {
            this.showPriceContainer();
            return;
          }

          try {
            const response = await fetch(`${baseUrl}/auctions/${variantId}/${dateForUrl}`);
            if (!response?.ok) {
              this.showPriceContainer();
              return;
            }

            const text = await response.text();
            let data;

            try {
              data = JSON.parse(text);
            } catch (e) {
              this.showPriceContainer();
              return;
            }

            const bidCount = data?.bcount ?? 0;
            const nextBid = data?.next;
            const highest = data?.highest;
            const isFinished = data?.ended ?? false;
            const statusLabel = isFinished ? 'Oferta finale' : 'Oferta aktuale';

            // If no bids, show "Cmimi fillestar" with the next bid value (which is the starting price)
            if (bidCount === 0) {
              if (nextBid !== null && nextBid !== undefined) {
                let nextBidNum = typeof nextBid === 'string'
                  ? Number(nextBid.replace(/,/g, '.'))
                  : Number(nextBid);

                if (!Number.isNaN(nextBidNum) && nextBidNum > 0) {
                  this.updatePrice(nextBidNum, 'Çmimi fillestar');
                  return;
                }
              }
              this.showPriceWithLabel('-', 'Çmimi fillestar');
              return;
            }

            // If there are bids, show "Oferta aktuale" with the highest bid
            if (highest === null || highest === undefined) {
              this.showPriceWithLabel('-', statusLabel);
              return;
            }

            let highestNum = typeof highest === 'string'
              ? Number(highest.replace(/,/g, '.'))
              : Number(highest);

            if (Number.isNaN(highestNum) || highestNum === 0) {
              this.showPriceWithLabel('-', statusLabel);
              return;
            }

            this.updatePrice(highestNum, statusLabel);
          } catch (error) {
            console.error('Error fetching auction price:', error);
            this.showPriceContainer();
          }
        }

        updatePrice(value, label = '') {
          const formatted = this.formatEuro(value);

          this.showPriceWithLabel(formatted, label);
        }

       showPriceWithLabel(priceText, label) {
    const priceContainer = this.querySelector('.price');
    if (!priceContainer) return;

    // Remove any existing auction label
    const existingLabel = priceContainer.querySelector('.auction-price-label');
    if (existingLabel) {
      existingLabel.remove();
    }

    const priceItem = priceContainer.querySelector('.price-item--regular, .price-item--sale');

    if (priceItem) {
      // Use innerHTML to make the label bold: "<strong>Oferta aktuale:</strong> €30.00"
      if (label) {
        priceItem.innerHTML = `<strong>${label}:</strong> ${priceText}`;
      } else {
        priceItem.textContent = priceText;
      }
    } else {
      const priceRegular = priceContainer.querySelector('.price__regular');
      if (priceRegular) {
        const newPriceItem = document.createElement('span');
        newPriceItem.className = 'price-item price-item--regular';
        if (label) {
          newPriceItem.innerHTML = `<strong>${label}:</strong> ${priceText}`;
        } else {
          newPriceItem.textContent = priceText;
        }
        priceRegular.innerHTML = '';
        priceRegular.appendChild(newPriceItem);
      }
    }

    const saleSpan = priceContainer.querySelector('.price__sale s');
    if (saleSpan) {
      saleSpan.style.display = 'none';
    }

    this.showPriceContainer();
  }

        hidePrice() {
          this.showPriceWithLabel('-', '');
        }

        formatEuro(value) {
          const numeric = typeof value === 'number'
            ? value
            : parseFloat(String(value).replace(',', '.')) || 0;

          return `€${numeric.toFixed(2)}`;
        }

        getAuctionStartTag(tagsString) {
          const tags = String(tagsString || '').split(/\s*,\s*|\s+/).map((t) => t.trim()).filter(Boolean);
          let latestTag = null;
          let latestComparableValue = '';

          tags.forEach((tag) => {
            if (!/^as:/i.test(tag)) {
              return;
            }

            const formatted = this.extractAuctionDateTimeForUrl(tag);
            if (!formatted) {
              return;
            }

            if (!latestTag || formatted > latestComparableValue) {
              latestComparableValue = formatted;
              latestTag = tag;
            }
          });

          return latestTag;
        }

        extractAuctionDateTimeForUrl(auctionStartTag) {
          let startDate = auctionStartTag;
          const startMatch = String(auctionStartTag).match(/^as:(.*)$/i);
          if (startMatch && startMatch[1]) startDate = startMatch[1];

          let dateStr;
          let timeStr;

          const isoMatch = startDate.match(/(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2})/);
          if (isoMatch) {
            dateStr = isoMatch[1];
            timeStr = isoMatch[2];
          } else {
            const standardMatch = startDate.match(/(\d{4}-\d{1,2}-\d{1,2})\s+(\d{2}:\d{2})/);
            if (!standardMatch) {
              return null;
            }

            const [, year, month, day] = standardMatch[1].match(/(\d{4})-(\d{1,2})-(\d{1,2})/);
            dateStr = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
            timeStr = standardMatch[2];
          }

          return `${dateStr}T${timeStr}`;
        }
      }
    );
  }

  function redirectProductPageToAuctionIfNeeded() {
    const isProductPage = /^\/products\//i.test(window.location.pathname);
    if (!isProductPage) {
      return;
    }

    const auctionAppUrl = window.__APP_CONFIG__?.AUCTION_APP_URL || 'https://auction.ankandet.com';
    if (window.location.href.startsWith(auctionAppUrl)) {
      return;
    }

    const tagsString = getCurrentProductTagsString();
    const auctionTag = getAuctionStartTagFromString(tagsString);
    if (!auctionTag) {
      return;
    }

    const formattedDateTime = extractAuctionDateTimeFromTag(auctionTag);
    if (!formattedDateTime) {
      return;
    }

    const variantId = getCurrentProductVariantId();
    if (!variantId) {
      return;
    }

    const auctionUrl = `${auctionAppUrl}/auction/${variantId}/${formattedDateTime}`;
    window.location.replace(auctionUrl);
  }

  function getCurrentProductTagsString() {
    const tagsString = document.querySelector('[data-product-tags]')?.dataset?.productTags;
    if (typeof tagsString === 'string' && tagsString.trim().length > 0) {
      return tagsString;
    }

    return '';
  }

  function getCurrentProductVariantId() {
    const variantId = document.querySelector('[data-selected-variant-id]')?.dataset?.selectedVariantId;
    if (typeof variantId === 'string' && variantId.trim().length > 0) {
      return variantId.trim();
    }

    return null;
  }

  function getAuctionStartTagFromString(tagsString) {
    const tags = String(tagsString || '').split(/\s*,\s*|\s+/).map((t) => t.trim()).filter(Boolean);
    let latestTag = null;
    let latestComparableValue = '';

    tags.forEach((tag) => {
      if (!/^as:/i.test(tag)) {
        return;
      }

      const formatted = extractAuctionDateTimeFromTag(tag);
      if (!formatted) {
        return;
      }

      if (!latestTag || formatted > latestComparableValue) {
        latestComparableValue = formatted;
        latestTag = tag;
      }
    });

    return latestTag;
  }

  function extractAuctionDateTimeFromTag(auctionStartTag) {
    let startDate = auctionStartTag;
    const startMatch = String(auctionStartTag).match(/^as:(.*)$/i);
    if (startMatch && startMatch[1]) {
      startDate = startMatch[1];
    }

    const isoMatch = startDate.match(/(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2})/);
    if (isoMatch) {
      return `${isoMatch[1]}T${isoMatch[2]}`;
    }

    const standardMatch = startDate.match(/(\d{4}-\d{1,2}-\d{1,2})\s+(\d{2}:\d{2})/);
    if (!standardMatch) {
      return null;
    }

    const [, year, month, day] = standardMatch[1].match(/(\d{4})-(\d{1,2})-(\d{1,2})/);
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}T${standardMatch[2]}`;
  }
